import React, { useState, useEffect } from "react";
import { Accordion } from "react-bootstrap";
import InnerHeader from "../components/InnerHeader";
import ContestDetails from "../components/ContestDetails";
import InnerPageWrap from "../components/InnerPageWrap";
import "../styles/joincontest.scss";
import { pageURLs } from "../appData/pageURLs";
import { useParams, useNavigate } from 'react-router-dom'
import * as contestService from "../services/contestService";
import {store} from '../appState/store';
import useSiteState from '../appState/siteState/useSiteState';
import ScoringRules from "../components/NFL/ScoringRules";
import ScoringRulesnba from "../components/NBA/ScoringRules";
import * as commonService from "../services/commonService";

const JoinContest = (props) => {
    const userData = store.getState().user
    const siteState = useSiteState();
    const [contestData, setContestData] = useState(null);
    const [defaultAccordion, setDefaultAccordion] = useState("0");
    const [totalContestLineUp, setTotalContestLineUp] = useState(0);
    const navigate = useNavigate();
    let { sportsleague, id} = useParams()
    id = parseInt(id);   
    let user_id = parseInt(userData.user.user_id);   
    const availablegames =  commonService.availableGames()
    
    if(!id || !availablegames.includes(sportsleague)) {
        navigate(pageURLs.lobby);
    }
    

    

    useEffect( async() => {
        await siteState.action.removeAllLineUpPlayers();
       //contestService.getSiteContest(user_id, id)
        contestService.getSiteContest(id, sportsleague)
            .then(response => {
                if (response.errorCode == 200) {
                    if(!response.data.contestDetails[0]) {
                        navigate(pageURLs.lobby);
                    }
                    if(response.data.contestDetails[0].contest_type_id != 2) {
                        setDefaultAccordion("1")
                    }
                    if(response.data.contestUserData.length > 0 && (response.data.contestUserData[0].contest_user_status_id == 1 || response.data.contestUserData[0].contest_user_status_id == 2)) {
                        let lineupPage = pageURLs.createlineup;
                        if(sportsleague === 'NBA') {
                            lineupPage = pageURLs.NBAcreatelineup;
                        }
                        navigate(lineupPage+'/'+id);
                    }
                    setTotalContestLineUp(response.data.contest_total_line_up);
                    setContestData(response.data);
                } else {
                    navigate(pageURLs.lobby);
                }
            })
            .catch(err => {
                console.log("Error", err);
            });
    }, []);
    
    return (
        <InnerPageWrap>
            <div className="koinner-sec">
                <div className="koheader-wrap"><InnerHeader currentPage={pageURLs.joincontest} /></div>
                <div className="kodata-content">
                    <div className="joincontest-container">
                        <div className="contest-detail-wrap"> 
                            {contestData && <ContestDetails contestData={contestData} totalContestLineUp = {totalContestLineUp} sportsleague ={sportsleague}/>}
                        </div>
                        <div className="contest-info-wrap"   >
                      { sportsleague === "NFL"  ? <ScoringRules/> : null} 
                      { (sportsleague === "NBA" && contestData) ? <ScoringRulesnba scoringRule={contestData.contestDetails[0].score_type_code}/> : null}

                           {/* {contestData && <Accordion defaultActiveKey={defaultAccordion} className="rules-accordion">
                                {contestData && contestData.contestDetails[0].contest_type_id == 2 && <Accordion.Item eventKey="0">
                                    <Accordion.Header>Knockout Plus Variant</Accordion.Header>
                                    <Accordion.Body>
                                        <p>Just like in our standard contests, there is only one winner in the elimination contest. That winner is the Champion of the Knockout Plus. However, additional prizes are awarded to:</p>
                                        <p>Weekly High Scores (criteria varies by contest)</p>
                                        <p>Season Long Points Totals (number of winners varies by contest)</p>
                                        <div className="play-basics">
                                            <h5>Fantasy Sports Knockout uses the following standard scoring:</h5>
                                            <div className="scoring-data">
                                                <div className="player-position">
                                                    <h5>OFFENSE</h5>
                                                    <h6>Each Yard:</h6>
                                                    <p>Passing: 0.04 points</p>
                                                    <p>Receiving/Rushing: 0.1 point</p>
                                                    <h6>Touchdowns:</h6>
                                                    <p>Passing: 4 points</p>
                                                    <p>ALL other TDs scored by a player (including receiving, rushing, special teams and turnover recoveries): 6 points</p>
                                                    <p>All Turnovers (fumbles lost, interceptions thrown): -2 points</p>
                                                    <p>Receptions: 1 point each</p>
                                                    <p>2-point conversion (all types): 2 points</p>
                                                </div>
                                                <div className="player-position special">
                                                    <h5>DST</h5>
                                                    <p>All Touchdowns: 6 points</p>
                                                    <p>All Turnovers (fumbles recovered, interceptions): 2 points</p>
                                                    <p>Sacks: 1 point</p>
                                                    <p>Safety: 2 points</p>
                                                    <p>1-point Safety: 1 point</p>
                                                </div>
                                                <div className="player-position">
                                                    <h5>KICKER</h5>
                                                    <p>Extra Points: 1 point</p>
                                                    <p>Field Goal 0-39: 3 points</p>
                                                    <p>Field Goal 40-49: 4 points</p>
                                                    <p>Field Goal 50+: 5 points</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                }
                               

                                 <Accordion.Item eventKey="1">
                                    <Accordion.Header>Weekly Elimination Formula</Accordion.Header>
                                    <Accordion.Body>
                                        <p>Example Only</p>
                                        <div className="tags-sec">
                                            <span className="tag">100 player contest with 13 weeks</span><span className="tag">1st Half: 6 weeks - 2nd Half: 7 weeks</span>
                                            <span className="tag">Alive for 2nd half: 8</span><span className="tag">Eliminated 1st half: 92</span><span className="tag">92 / 6 =15.3, rounded down to 15</span>
                                            <span className="tag">15 (per week) x 6 (weeks) = 90</span><span className="tag">92 - 90 = 2</span>
                                            <span className="tag">Two (2) additional eliminated in week 1 (17)</span>
                                        </div>
                                        <p>For the final half of the contest, we will eliminate one (1) user per week. For the first half of the contest, we will eliminate all other users. We determine the number of weeks in each half by dividing the number of weeks in the contest by 2.
                                            If the contest contains an odd number of weeks, the second half will contain the higher number of weeks. Subtract the number of weeks in the second half and add one to determine how many users will be alive for the second half.
                                            Subtract the number from the previous example from the total number of users in the contest to determine how many will be eliminated in the first half. Divide the sum of users that will be eliminated in the first half equally
                                            amongst the weeks in the first half. In most cases, this will not be a round number. Therefore, round the calculated result down, and eliminate the remainder in Week 1.</p>
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Scoring Rules</Accordion.Header>
                                    <Accordion.Body>
                                      <div className="scoring-data rules-card-data">
                                            <div className="player-position">
                                                <h4>OFFENSIVE SCORE</h4>
                                                <div className="info-block">
                                                    <h5>Passing Scoring rules </h5>
                                                    <p>For each passing yard: 0.04 point </p>
                                                    <p>For each passing TD: 4 points</p>
                                                </div>
                                                <div className="info-block">
                                                    <h5>Rushing Scoring rule</h5>
                                                    <p>For each rushing yard: 0.1 point </p>
                                                </div>
                                                <div className="info-block">
                                                    <h5>Reception Scoring rules</h5>
                                                    <p>For each receiving yard: 0.1 point </p>
                                                    <p>For each reception: 1 point</p>
                                                </div>
                                                <div className="info-block">
                                                    <h5>All other TDS (rushing, reception, turn over recoveries ): 6 points</h5>
                                                    <h5>Two point conversion: 2 points</h5><h5>All turnovers: -2</h5>
                                                </div>
                                            </div>
                                            <div className="player-position kicker-card"><h4>KICKER</h4><p>Extra points: 1 point</p>
                                                <p>Field Goal 0-39: 3 points</p>
                                                <p>Field Goal 40-49: 4 points</p><p>Field Goal 50+:  5 points</p>
                                            </div>
                                            <div className="player-position "><h4>DST</h4>
                                                <p>All TDS: 6 points</p>
                                                <p>All turnovers: 2 points</p>
                                                <p>Sacks: 1 point</p><p>Safety: 2 points</p>
                                            </div>
                                        </div>
                                        
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="3">
                                   <Accordion.Header>Lineup Requirements</Accordion.Header>
                                    <Accordion.Body>
                                     <p>QB - 1, WR - 3, RB - 2, FLEX - 1, K - 1, TE - 1, DST - 1</p>
                                    
                                    </Accordion.Body>
                                </Accordion.Item>
                                
                              
                            </Accordion>}*/}



                                





                        </div>
                    </div>
                </div>
            </div>
        </InnerPageWrap>
    );
};

export default JoinContest;
